import moment from 'moment'

export default class ProductService {

  constructor (product) {

  }
  priceToOrderProduct (orderProduct) {
    let price = 0;
    let qty = 0;
    const product = this.prdtPrice(orderProduct, true)
    let options = orderProduct.options || orderProduct.productOptions

    if (orderProduct.options) {
      options.forEach((x) => {
        // 옵션 없을 떄
        if (x.name !== '') {
          price +=
            product.value * x.count

          // 옵션 있을 떄
        } else {
          price +=
            (product.value +
              x.price) *
            x.count
        }
        qty += x.count
      })
    } else {
      console.log(orderProduct)
      options.forEach((x) => {
        price +=
          (product.value +
            x.price) *
          x.count
        qty += x.count
      })
    }


    return {price: price, qty: qty}
  } 

  // 상품 금액, 할인율 리턴 함수
  prdtPrice (product, isOnlyMember) {
    let priceObj = {
      value: 0,
      discountRate: 0,
      discount: 0,
      isLiveCheck: false
    }

    priceObj.value = product.price
    priceObj.discount = product.discount || 0
    priceObj.discountRate = product.discountRate || 0

    const token = sessionStorage.getItem('accessToken');
    if (isOnlyMember && !token) { return priceObj }

    if (product.isLivePrice === 1) {
      const today = moment(new Date())
      const stDate = moment(product.livePriceStartDate)
      const edDate = moment(product.livePriceEndDate)

      const stFlag = today.diff(stDate) >= 0
      const edFlag = today.diff(edDate) < 0

      // 라이브가 적용
      if (stFlag && edFlag) {
        priceObj.value = product.livePrice
        priceObj.discount = product.liveDiscount || 0
        priceObj.discountRate = product.liveDiscountRate || 0
        priceObj.isLiveCheck = true
      }

    }
    
    return priceObj
  }
}
